import BaseComponent from 'foundation/base-component';
import app from '../../../general/js/app';
import Cookies from 'js-cookie';

export default class OneClubButton extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        const userDataCookie = Cookies.get(app.state.userDataCookieName);
        if (userDataCookie !== undefined) {
            const userData = JSON.parse(userDataCookie);
            if (userData !== undefined && userData.isSignedIn && userData.isOneClubMember) {
                this.element.classList.add('hidden');
            }
        }
    }
}
